export const riskProfileDeclaration = `I have understood the above questionnaire and all the answers given by me for each of the questions are true to the best of
my knowledge and belief.`;
export const riskProfileDonotWish =
  'I do not wish to undergo the RISK Profiling and want to use the platform of products and services as execution only platform, whereby all investment decisions would be my sole discretion and decision';

export const importantUpdatesDeclaration =
  'I hereby authorize NAM India to send important information and regulatory updates to me on my number';
